var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "room-type-list" },
    [
      _c("div", { staticClass: "section-title" }, [_vm._v("当前订单信息")]),
      _vm._l(_vm.roomList, function (item, idx) {
        return [
          idx > 0
            ? _c("div", { key: "divider-" + idx, staticClass: "item-divider" })
            : _vm._e(),
          _c("div", { key: item.id || idx, staticClass: "room-item" }, [
            _c("div", { staticClass: "room-head" }, [
              _c("div", { staticClass: "room-name-row" }, [
                _c("span", { staticClass: "room-name" }, [
                  _vm._v(_vm._s(item.productNameCn || item.productNameEn)),
                ]),
                item.cancelNumber > 0 &&
                item.cancelNumber <
                  item.number * _vm.days(item.startTime, item.endTime)
                  ? _c("span", { staticClass: "room-cancel-tag" }, [
                      _vm._v("已取消" + _vm._s(item.cancelNumber) + "间"),
                    ])
                  : _vm._e(),
                item.cancelNumber >=
                item.number * _vm.days(item.startTime, item.endTime)
                  ? _c("span", { staticClass: "room-cancel-tag cancel-all" }, [
                      _vm._v("已全部取消"),
                    ])
                  : _vm._e(),
                item.cancelNumber > 0 &&
                item.cancelDetailList &&
                item.cancelDetailList.length
                  ? _c(
                      "span",
                      {
                        staticClass: "cancel-detail-btn",
                        on: {
                          click: function ($event) {
                            return _vm.showCancelDetail(item)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-info",
                          staticStyle: {
                            color: "#E74C3C",
                            "font-size": "14px",
                          },
                        }),
                        _vm._v(" 详情 "),
                      ]
                    )
                  : _vm._e(),
              ]),
              _c("span", { staticClass: "room-count" }, [
                _vm._v(_vm._s(item.number || 1)),
                _c("span", { staticClass: "count-unit" }, [_vm._v("间")]),
                _c("span", { staticStyle: { "font-size": "12px" } }, [
                  _vm._v("/每天"),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "room-info" },
              [
                _c("span", [
                  _vm._v(
                    "可住" +
                      _vm._s(
                        (item.productDetail && item.productDetail.useNumber) ||
                          2
                      ) +
                      "人"
                  ),
                ]),
                item.productDetail && item.productDetail.bedInfoStr
                  ? [
                      _c("span", { staticClass: "dot" }, [_vm._v("·")]),
                      _c("span", [
                        _vm._v(_vm._s(item.productDetail.bedInfoStr)),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _c("div", { staticClass: "room-date" }, [
              _vm._v(_vm._s(item.checkInDate)),
            ]),
          ]),
        ]
      }),
      !_vm.loading && _vm.roomList.length === 0
        ? _c("div", { staticClass: "empty-tip" }, [_vm._v("暂无房型信息")])
        : _vm._e(),
      _vm.loading
        ? _c("div", { staticClass: "empty-tip" }, [_vm._v("加载中...")])
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "",
            visible: _vm.cancelDialogVisible,
            width: "480px",
            "append-to-body": "",
            "custom-class": "cancel-detail-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.cancelDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-title-bar",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("span", [
                _vm._v("取消详情 — " + _vm._s(_vm.cancelDetailRoomName)),
              ]),
            ]
          ),
          _c("div", { staticClass: "popup-body" }, [
            _c("div", { staticClass: "detail-summary" }, [
              _c("span", { staticClass: "summary-label" }, [
                _vm._v("房型名称"),
              ]),
              _c("span", { staticClass: "summary-value" }, [
                _vm._v(_vm._s(_vm.cancelDetailRoomName)),
              ]),
            ]),
            _c("div", { staticClass: "detail-summary" }, [
              _c("span", { staticClass: "summary-label" }, [
                _vm._v("累计取消"),
              ]),
              _c("span", { staticClass: "summary-value summary-total" }, [
                _vm._v(_vm._s(_vm.cancelDetailTotal) + " 间"),
              ]),
            ]),
            _c("div", { staticClass: "detail-table" }, [
              _c("div", { staticClass: "table-head" }, [
                _c("span", { staticClass: "th date-col" }, [_vm._v("日期")]),
                _c("span", { staticClass: "th qty-col" }, [_vm._v("取消数量")]),
              ]),
              _c(
                "div",
                {
                  staticClass: "table-body",
                  style: { maxHeight: _vm.detailTableMaxHeight },
                },
                _vm._l(_vm.cancelDetailData, function (row, dIdx) {
                  return _c(
                    "div",
                    {
                      key: dIdx,
                      staticClass: "table-row",
                      class: {
                        "row-last": dIdx === _vm.cancelDetailData.length - 1,
                      },
                    },
                    [
                      _c("span", { staticClass: "td date-col" }, [
                        _vm._v(_vm._s(_vm.formatUseDate(row.useDate))),
                      ]),
                      _c("span", { staticClass: "td qty-col" }, [
                        _vm._v(_vm._s(row.cancelNumber) + " 间"),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.closeCancelDetail } }, [
                _vm._v("关闭"),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }